// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__oZt0R","heading":"Header_heading__1WYFZ"};